// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file router/router_requests.proto (package com.gem.router.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file router/router_requests.proto.
 */
export const file_router_router_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chxyb3V0ZXIvcm91dGVyX3JlcXVlc3RzLnByb3RvEhdjb20uZ2VtLnJvdXRlci5jb250cmFjdCIeCg1Sb3V0ZXJSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJIikKFVJvdXRlckRlZXBsaW5rUmVxdWVzdBIQCghkZWVwbGluaxgBIAEoCSIvChlHZXRCZmZCYXNlVXJsQnlSZWdpb25OYW1lEhIKCnJlZ2lvbk5hbWUYASABKAkilwEKD0Rpc2NvdmVyUmVxdWVzdBISCgVlbWFpbBgBIAEoCUgAiAEBEhQKB29yZ1NsdWcYAiABKAlIAYgBARI7CgR0eXBlGAMgASgOMiguY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuRGVzdGluYXRpb25UeXBlSAKIAQFCCAoGX2VtYWlsQgoKCF9vcmdTbHVnQgcKBV90eXBlIl8KFkRpc2NvdmVyQmFzZVVybFJlcXVlc3QSNgoEdHlwZRgBIAEoDjIoLmNvbS5nZW0ucm91dGVyLmNvbnRyYWN0LkRlc3RpbmF0aW9uVHlwZRINCgVhbGlhcxgCIAEoCSpGCg9EZXN0aW5hdGlvblR5cGUSDgoKQ0xPVURfT05MWRAAEhMKD09OX1BSRU1JU0VfT05MWRABEg4KCkFMTF9JTl9PTkUQAio9CglNYXRjaGVkQnkSGgoWTUFUQ0hFRF9CWV9VTlNQRUNJRklFRBAAEgoKBkRPTUFJThABEggKBFNMVUcQAkIbChdjb20uZ2VtLnJvdXRlci5jb250cmFjdFABYgZwcm90bzM'
  );

/**
 * @generated from message com.gem.router.contract.RouterRequest
 */
export type RouterRequest = Message<'com.gem.router.contract.RouterRequest'> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message com.gem.router.contract.RouterRequest.
 * Use `create(RouterRequestSchema)` to create a new message.
 */
export const RouterRequestSchema: GenMessage<RouterRequest> =
  /*@__PURE__*/
  messageDesc(file_router_router_requests, 0);

/**
 * @generated from message com.gem.router.contract.RouterDeeplinkRequest
 */
export type RouterDeeplinkRequest = Message<'com.gem.router.contract.RouterDeeplinkRequest'> & {
  /**
   * @generated from field: string deeplink = 1;
   */
  deeplink: string;
};

/**
 * Describes the message com.gem.router.contract.RouterDeeplinkRequest.
 * Use `create(RouterDeeplinkRequestSchema)` to create a new message.
 */
export const RouterDeeplinkRequestSchema: GenMessage<RouterDeeplinkRequest> =
  /*@__PURE__*/
  messageDesc(file_router_router_requests, 1);

/**
 * @generated from message com.gem.router.contract.GetBffBaseUrlByRegionName
 */
export type GetBffBaseUrlByRegionName =
  Message<'com.gem.router.contract.GetBffBaseUrlByRegionName'> & {
    /**
     * @generated from field: string regionName = 1;
     */
    regionName: string;
  };

/**
 * Describes the message com.gem.router.contract.GetBffBaseUrlByRegionName.
 * Use `create(GetBffBaseUrlByRegionNameSchema)` to create a new message.
 */
export const GetBffBaseUrlByRegionNameSchema: GenMessage<GetBffBaseUrlByRegionName> =
  /*@__PURE__*/
  messageDesc(file_router_router_requests, 2);

/**
 * @generated from message com.gem.router.contract.DiscoverRequest
 */
export type DiscoverRequest = Message<'com.gem.router.contract.DiscoverRequest'> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string orgSlug = 2;
   */
  orgSlug?: string;

  /**
   * @generated from field: optional com.gem.router.contract.DestinationType type = 3;
   */
  type?: DestinationType;
};

/**
 * Describes the message com.gem.router.contract.DiscoverRequest.
 * Use `create(DiscoverRequestSchema)` to create a new message.
 */
export const DiscoverRequestSchema: GenMessage<DiscoverRequest> =
  /*@__PURE__*/
  messageDesc(file_router_router_requests, 3);

/**
 * @generated from message com.gem.router.contract.DiscoverBaseUrlRequest
 */
export type DiscoverBaseUrlRequest = Message<'com.gem.router.contract.DiscoverBaseUrlRequest'> & {
  /**
   * @generated from field: com.gem.router.contract.DestinationType type = 1;
   */
  type: DestinationType;

  /**
   * @generated from field: string alias = 2;
   */
  alias: string;
};

/**
 * Describes the message com.gem.router.contract.DiscoverBaseUrlRequest.
 * Use `create(DiscoverBaseUrlRequestSchema)` to create a new message.
 */
export const DiscoverBaseUrlRequestSchema: GenMessage<DiscoverBaseUrlRequest> =
  /*@__PURE__*/
  messageDesc(file_router_router_requests, 4);

/**
 * @generated from enum com.gem.router.contract.DestinationType
 */
export enum DestinationType {
  /**
   * @generated from enum value: CLOUD_ONLY = 0;
   */
  CLOUD_ONLY = 0,

  /**
   * @generated from enum value: ON_PREMISE_ONLY = 1;
   */
  ON_PREMISE_ONLY = 1,

  /**
   * @generated from enum value: ALL_IN_ONE = 2;
   */
  ALL_IN_ONE = 2,
}

/**
 * Describes the enum com.gem.router.contract.DestinationType.
 */
export const DestinationTypeSchema: GenEnum<DestinationType> =
  /*@__PURE__*/
  enumDesc(file_router_router_requests, 0);

/**
 * @generated from enum com.gem.router.contract.MatchedBy
 */
export enum MatchedBy {
  /**
   * @generated from enum value: MATCHED_BY_UNSPECIFIED = 0;
   */
  MATCHED_BY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOMAIN = 1;
   */
  DOMAIN = 1,

  /**
   * @generated from enum value: SLUG = 2;
   */
  SLUG = 2,
}

/**
 * Describes the enum com.gem.router.contract.MatchedBy.
 */
export const MatchedBySchema: GenEnum<MatchedBy> =
  /*@__PURE__*/
  enumDesc(file_router_router_requests, 1);
